import "../css/overlay.css";
import OverlayCanvas from "../components/overlay/OverlayCanvas";
import OverlayRunController from "../components/overlay/OverlayRunController";
import OverlayScreenQueryController from "../components/overlay/OverlayScreenQueryController";
import OverlayUserInterface from "../components/overlay/OverlayUserInterface";
import {OverlayProvider} from "../contexts/OverlayContext";
import {usePageTitle} from "../hooks/usePageTitle";


const Overlay = () => {
  usePageTitle("Overlay View");

  return <div id="overlay-page">
    <OverlayProvider>
      <OverlayCanvas/>
      <OverlayScreenQueryController/>
      <OverlayRunController/>
      <OverlayUserInterface/>
    </OverlayProvider>
  </div>;
};

export default Overlay;
